// © Microsoft Corporation. All rights reserved.
import { WebWorkerMessageId } from "./Constants";
import { environment } from "./Environment";
import { notifySubscription } from "./PostMessage";
/** The Logger class has methods to log info, error to console. */
class Logger {
    /**
     * When in debug mode, log message to console.
     * @param message - The message
     */
    info(message) {
        if (environment.isDebug) {
            console.log(message);
        }
    }
    /**
     * Logs message to error console.
     * @param message - The message
     */
    error(message) {
        notifySubscription(WebWorkerMessageId.WebWorkerError, message);
        // Avoid logging errors unless in debug mode.
        if (environment.isDebug) {
            console.error(message);
        }
    }
}
/** Singleton class instance. */
export const logger = new Logger();
//# sourceMappingURL=Logger.js.map